
import { ArrowRight, Gauge, Inbox, ShieldCheck, Users } from 'lucide-react'
import { Link } from 'react-router-dom'
import { HomeOutcomes } from '../../components/HomeOutcomes'

export function Home() {
  return <>
    <section className="public-hero public-container">
      <div className="public-hero-layout">
        <div className="public-hero-copy">
          <h1>Never let a warm lead go cold in the inbox.</h1>
          <p className="public-lead">
            Mail Percent shows you where customer emails are slowing down, where follow-ups are being missed and where your team needs attention — so you can protect conversions, retain customers and keep communication standards high.
          </p>

          <div className="public-hero-actions">
            <Link to="/signup" className="button primary public-cta">Get started <ArrowRight size={17}/></Link>
            <Link to="/product" className="button ghost public-cta">See how Mail Percent helps</Link>
          </div>
        </div>

        <HomeOutcomes/>
      </div>
    </section>

    <section className="public-section public-container">
      <div className="public-section-heading">
        <span className="public-kicker">What Mail Percent shows you</span>
        <h2>See what happens between an email arriving and your team responding.</h2>
        <p>
          Mail Percent brings together arrival timing, response progress, queue pressure, workload and SLA Performance so managers can see where customer email work is slowing down.
        </p>
      </div>

      <div className="public-feature-grid three">
        <article className="public-feature-card">
          <div className="feature-icon"><Inbox/></div>
          <h3>See response gaps</h3>
          <p>
            See how long customer emails wait for a reply, how queues build and whether response SLAs are being met.
          </p>
          <Link to="/product">See opportunity visibility <ArrowRight size={15}/></Link>
        </article>

        <article className="public-feature-card">
          <div className="feature-icon"><Users/></div>
          <h3>See team follow-through</h3>
          <p>
            See who is handling customer email, what remains open and how response activity compares with the workload your team is carrying.
          </p>
          <Link to="/teams">See team accountability <ArrowRight size={15}/></Link>
        </article>

        <article className="public-feature-card">
          <div className="feature-icon"><Gauge/></div>
          <h3>Use standards with context</h3>
          <p>
            Set response standards by team, category and complexity, then read the result alongside queue pressure and capacity.
          </p>
          <Link to="/how-it-works">See how it works <ArrowRight size={15}/></Link>
        </article>
      </div>
    </section>

    <section className="public-section public-section-dark">
      <div className="public-container public-split-section">
        <div>
          <span className="public-kicker dark">Works around the inbox your team already uses</span>
          <h2>Keep Gmail or Outlook. Add the visibility your organisation is missing.</h2>
          <p>
            Mail Percent sits beside your existing email workflow to show response gaps, queue pressure, workload and follow-through without forcing your team into a replacement inbox.
          </p>
          <Link to="/integrations" className="button light public-cta">Explore integrations <ArrowRight size={16}/></Link>
        </div>

        <div className="provider-stack">
          <div>
            <span className="provider-letter"><img src="/images/integrations/gmail-logo.png" alt="Gmail" /></span>
            <div>
              <strong>Google Gmail</strong>
              <span>Customer email timing + provider API measurement</span>
            </div>
            <b>Connected</b>
          </div>

          <div>
            <span className="provider-letter ms"><img src="/images/integrations/outlook-logo.png" alt="Microsoft Outlook" /></span>
            <div>
              <strong>Microsoft Outlook</strong>
              <span>Customer email timing + provider API measurement</span>
            </div>
            <b>Supported</b>
          </div>

          <div className="privacy-note">
            <ShieldCheck size={19}/>
            <div>
              <strong>Accountability without unnecessary content storage</strong>
              <span>Core operational records avoid storing message body, subject, snippet and attachments.</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="public-section public-container public-final-cta">
      <div>
        <span className="public-kicker">Bring customer email work into view</span>
        <h2>See what needs attention before the day gets away from your team.</h2>
        <p>
          Connect your organisation, invite the team and start measuring the customer email work already happening in Gmail or Outlook.
        </p>
      </div>

      <div>
        <Link to="/signup" className="button primary public-cta">Create your organisation <ArrowRight size={17}/></Link>
        <Link to="/security" className="button ghost public-cta">Read about privacy</Link>
      </div>
    </section>
  </>
}
